import { Language as LanguageIcon } from '@mui/icons-material';
import { MenuItem, ListItemText } from '@mui/material';
import { useCallback } from 'react';

import { useDefaultLocale } from 'applications/GSP/shared/hooks/localization';
import { useSupportedLocales } from 'applications/GSP/shared/hooks/localization/useDefaultLocale/hooks';
import { Menu } from 'shared/components/Menu';
import { useMenu } from 'shared/components/Menu/hooks';
import { ArrowDropdownIcon } from 'shared/components/icons/ArrowDropdownIcon';

import { LocaleButton } from './components/LocaleButton';
import { useSelectLocale, useIsMutatingUserSettings } from './hooks';

import type { InspiredGlobalStudyPlatformApiModelsSchoolSettingsSupportedLocale as LocaleType } from 'applications/GSP/shared/api/gsp';

export const Locale = () => {
  const { open, onClose, onOpen, anchorEl } = useMenu();
  const locale = useDefaultLocale();
  const { supportedLocales } = useSupportedLocales();
  const selectLocale = useSelectLocale();
  const isMutating = useIsMutatingUserSettings();

  const handleClick = useCallback(
    (localeId: LocaleType['id']) => {
      onClose();

      if (locale === localeId) return;

      selectLocale(localeId);
    },
    [selectLocale, onClose, locale],
  );

  if (supportedLocales.length < 2) return null;

  return (
    <>
      <LocaleButton
        onClick={onOpen}
        startIcon={<LanguageIcon />}
        endIcon={<ArrowDropdownIcon opened={open} color="primary" />}
        loading={isMutating}
      >
        {locale}
      </LocaleButton>
      <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
        {supportedLocales.map(({ id, name }) => (
          <MenuItem
            key={id}
            selected={id === locale}
            onClick={() => handleClick(id)}
          >
            <ListItemText>{name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
